import React, { FC } from 'react';
import { Field } from 'react-final-form';
import { RadioCardWrapper } from 'components/forms';
import styles from './Form.module.scss';

export const formFields = [
  {
    label: 'form.field.label.private.usage',
    description: 'form.field.description.private.usage',
    name: 'isPublic',
    value: 'no',
  },
  {
    label: 'form.field.label.public.usage',
    description: 'form.field.description.public.usage',
    name: 'isPublic',
    value: 'yes',
  },
];

const AppsUsage: FC = (props) => (
  <div className={styles.fieldsContainer}>
    {formFields.map((field: any) => (
      <Field {...field} {...props} type='radio' component={RadioCardWrapper} key={field.value} />
    ))}
  </div>
);

export default AppsUsage;
